Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=









virtualize;var _react=require('react');var _react2=_interopRequireDefault(_react);var _reactAddonsShallowCompare=require('react-addons-shallow-compare');var _reactAddonsShallowCompare2=_interopRequireDefault(_reactAddonsShallowCompare);var _reactSwipeableViewsCore=require('react-swipeable-views-core');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LEFT_OFFSET=1;function virtualize(MyComponent){var
Virtualize=function(_Component){_inherits(Virtualize,_Component);function Virtualize(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Virtualize);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Virtualize.__proto__||Object.getPrototypeOf(Virtualize)).call.apply(_ref,[this].concat(args))),_this),_this.



















































state={},_this.





























timer=null,_this.

handleChangeIndex=function(indexContainer,indexLatest){var _this$props=



_this.props,slideCount=_this$props.slideCount,onChangeIndex=_this$props.onChangeIndex;

var indexDiff=indexContainer-indexLatest;
var index=_this.state.index+indexDiff;

if(slideCount){
index=(0,_reactSwipeableViewsCore.mod)(index,slideCount);
}


if(_this.props.index===undefined){
_this.setIndex(index,indexContainer,indexDiff);
}

if(onChangeIndex){
onChangeIndex(index,_this.state.index);
}
},_this.

handleTransitionEnd=function(){

_this.timer=setTimeout(function(){
_this.setWindow();
},0);

if(_this.props.onTransitionEnd){
_this.props.onTransitionEnd();
}
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Virtualize,[{key:'componentWillMount',value:function componentWillMount(){this.setState({index:this.props.index||0,indexContainer:this.props.overscanSlideCount});this.setWindow(this.props.index||0);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var index=nextProps.index;if(typeof index==='number'&&index!==this.props.index){var indexDiff=index-this.props.index;this.setIndex(index,this.state.indexContainer+indexDiff,indexDiff);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return(0,_reactAddonsShallowCompare2.default)(this,nextProps,nextState);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.timer);}},{key:'setIndex',value:function setIndex(

index,indexContainer,indexDiff){
var nextState={
index:index,
indexContainer:indexContainer,
indexStart:this.state.indexStart,
indexStop:this.state.indexStop};



if(indexDiff>0&&(
!this.props.slideCount||nextState.indexStop<this.props.slideCount-1)){
nextState.indexStop+=1;
}


if(index>nextState.indexStop){
nextState.indexStop=index;
}

var leftAhead=nextState.indexStart-index;


if(leftAhead>0){
nextState.indexContainer+=leftAhead;
nextState.indexStart-=leftAhead;
}

this.setState(nextState);
}},{key:'setWindow',value:function setWindow()

{var index=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.state.index;var

slideCount=
this.props.slideCount;

var leftAhead=this.props.overscanSlideCount+LEFT_OFFSET;
var rightAhead=this.props.overscanSlideCount;

if(slideCount){
if(leftAhead>index){
leftAhead=index;
}

if(rightAhead+index>slideCount-1){
rightAhead=slideCount-index-1;
}
}

this.setState({
indexContainer:leftAhead,
indexStart:index-leftAhead,
indexStop:index+rightAhead});

}},{key:'render',value:function render()

{var _props=








this.props,children=_props.children,indexProp=_props.index,onChangeIndex=_props.onChangeIndex,overscanSlideCount=_props.overscanSlideCount,slideCount=_props.slideCount,slideRenderer=_props.slideRenderer,other=_objectWithoutProperties(_props,['children','index','onChangeIndex','overscanSlideCount','slideCount','slideRenderer']);var _state=





this.state,indexContainer=_state.indexContainer,indexStart=_state.indexStart,indexStop=_state.indexStop;

var slides=[];

for(var slideIndex=indexStart;slideIndex<=indexStop;slideIndex+=1){
slides.push(slideRenderer({
index:slideIndex,
key:slideIndex}));

}

return(
_react2.default.createElement(MyComponent,_extends({
index:indexContainer,
onChangeIndex:this.handleChangeIndex,
onTransitionEnd:this.handleTransitionEnd},
other),

slides));


}}]);return Virtualize;}(_react.Component);Virtualize.propTypes={children:function children(props,propName){if(props[propName]!==undefined){return new Error("The children property isn't supported.");}return null;},index:_react.PropTypes.number,onChangeIndex:_react.PropTypes.func,onTransitionEnd:_react.PropTypes.func,overscanSlideCount:_react.PropTypes.number,slideCount:_react.PropTypes.number,slideRenderer:_react.PropTypes.func.isRequired};Virtualize.defaultProps={overscanSlideCount:2};


return Virtualize;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views-utils/lib/virtualize.js
// module id = 732
// module chunks = 0